import React from "react";

import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

type AccountScoreGaugeProps = {
  score: number | null;
};

const FILL_COLOR = "#FFCA5D";
const TRACK_COLOR = "#E9EDF0";

/** Semicircle gauge: full circle clipped to top half. */
const GAUGE_W = 88;
const GAUGE_H = 44;

const gaugeStyles = buildStyles({
  rotation: 0.75,
  strokeLinecap: "round",
  pathColor: FILL_COLOR,
  trailColor: TRACK_COLOR,
  pathTransition: "none",
  textSize: "0px",
});

gaugeStyles.trail!.strokeWidth = 3;
gaugeStyles.path!.strokeWidth = 10;

const AccountScoreGauge: React.FC<AccountScoreGaugeProps> = ({ score }) => {
  const hasScore = score !== null && !Number.isNaN(score);
  const value = hasScore ? Math.min(100, Math.max(0, score)) : 0;

  return (
    <div
      className="mx-auto w-[5.5rem] shrink-0 text-center"
      aria-label="Account score"
    >
      <div
        className="relative mx-auto overflow-hidden"
        style={{ width: GAUGE_W, height: GAUGE_H }}
      >
        <div style={{ width: GAUGE_W, height: GAUGE_W }}>
          <CircularProgressbar
            value={value}
            maxValue={100}
            circleRatio={0.5}
            strokeWidth={10}
            text=""
            styles={gaugeStyles}
          />
        </div>
        <span
          className="pointer-events-none absolute left-1/2 z-10 -translate-x-1/2 text-sm font-semibold leading-none text-[#404040]"
          style={{ top: "36%" }}
        >
          {hasScore ? `${Math.round(value)}%` : "%"}
        </span>
      </div>
      <span className="mt-1 block text-[11px] font-normal leading-none text-[#404040]">
        Account Score
      </span>
    </div>
  );
};

export default AccountScoreGauge;
